// Keep the category structure as it's used for UI organization
export const pizzaCategories = {
  speciales: 'speciales',
  incontournables: 'incontournables',
  fruitsmer: 'fruitsmer',
  mixtes: 'mixtes'
};

// Keep icons for UI
export const categoryIcons = {
  pizzas: "🍕",
  tacos: "🌮",
  burgers: "🍔",
  sandwiches: "🥪",
  burritos: "🌯",
  paninis: "🥖",
  plats: "🍽️",
  salades: "🥗",
  boissons: "🥤",
  desserts: "🍰"
};

// Keep category structure for navigation
export const menuCategories = {
  pizzas: "pizzas",
  burritos: "burritos",
  tacos: "tacos",
  sandwiches: "sandwiches",
  paninis: "paninis",
  plats: "plats",
  salades: "salades",
  boissons: "boissons"
};

// Remove the hardcoded menuItems array as we'll get it from the database